<div class="document-preview-dialog">
  <header class="document-preview-dialog__header">
    <h2>{{ data.fileName }}</h2>
    <button
      type="button"
      mat-icon-button
      aria-label="Close document preview"
      (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="document-preview-dialog__viewer">
    <app-pdf-apryse
      [filePath]="data.filePath"
      [fileName]="data.fileName"
      [isShowAnnotation]="false">
    </app-pdf-apryse>
  </div>
</div>
